import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_BASE_URL } from "../../config";

export const fetchAdminOverview = createAsyncThunk(
  "adminOverview/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("adminToken");
      const response = await axios.get(`${API_BASE_URL}/api/website/admin/overview`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to load mission control data"
      );
    }
  }
);

const adminOverviewSlice = createSlice({
  name: "adminOverview",
  initialState: {
    data: null,
    loading: false,
    error: null,
    lastFetchedAt: null,
  },
  reducers: {
    clearAdminOverviewError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminOverview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.lastFetchedAt = Date.now();
      })
      .addCase(fetchAdminOverview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load overview";
      });
  },
});

export const { clearAdminOverviewError } = adminOverviewSlice.actions;

export const selectAdminOverview = (state) => state.adminOverview.data;
export const selectAdminOverviewLoading = (state) => state.adminOverview.loading;
export const selectAdminOverviewError = (state) => state.adminOverview.error;
export const selectAdminOverviewLastFetched = (state) =>
  state.adminOverview.lastFetchedAt;

export default adminOverviewSlice.reducer;
